import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
//import { UsuariosFilter } from './usuarios-filter';
import { RenderFilters } from '../../../elements/render-filters';
import { ConductoresForm } from './conductores-form';
import { ConductoresFilter } from './conductores-filter';

export const Conductores = () => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    
    const filtrosGuardados = get('vehicles-filtroConductores') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));

    const handleNewAction = () => {
        navigate('/drivers/create')
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        open('common.filter.title', <ConductoresFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const openInNewTab = (item: any) => {
        window.open(item.photo, '_blank', 'noreferrer');
    };

    const doFilter = (filters: any) => {
        set('vehicles-filtroConductores', filters);
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        close();
    };

    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.conductores'}
            newActionTitle={'conductor.button.new'}
            filterAction={handleFilters}
            filters={filters}
        >
            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} />
                ) : (
                    ''
                )}
                <Table
                    path="/fleet/drivers/"
                    deletePath="/fleet/drivers/"
                    query={query}
                    callBeforeDrawerClosed={handleClose}
                    Form={ConductoresForm}
                    withPagination
                    //onShow={openInNewTab}
                    doEdit={(item: any) => navigate(`/drivers/${item.id}`)}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.label.name'
                        },
                        {
                            key: 'surname',
                            label: 'common.form-label.last_name'
                        },
                        {
                            key: 'available',
                            type: 'boolean',
                            label: 'common.form-label.disponible',
                        },
                        {
                            key: 'status',
                            type: 'status',
                            label: 'common.label.estado',
                        },
                        {
                            key: 'photo_display_url',
                            type: 'image',
                            label: 'common.form-label.foto',
                        },
                    ]}
                />
            </>
        </PageBody>
    );
};